
// mui
import { Box, Typography, Container } from "@mui/material";

// blocks
import ComplexesList from './ComplexesList'

export default function View() {
  return (
    <Container maxWidth="lg">
      <Box sx={{
        py: 10
      }}>
        <Typography variant="h1" component="h1" gutterBottom>
          Caribbean New Development Projects
        </Typography>
        <Typography variant="body1">
          Explore the best of Caribbean property developments with our selection of new luxury villas and condos for sale throughout the Caribbean region. Welcome to the future of Caribbean luxury living!
        </Typography>
      </Box>

      <ComplexesList />

    </Container>
  )
}